module.exports = __webpack_public_path__ + "static/media/photo-15.2f89fc0e.avif";